import { render, staticRenderFns } from "./automobileFour.vue?vue&type=template&id=2f2572bd&scoped=true"
import script from "./automobileFour.vue?vue&type=script&lang=js"
export * from "./automobileFour.vue?vue&type=script&lang=js"
import style0 from "./automobileFour.vue?vue&type=style&index=0&id=2f2572bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2572bd",
  null
  
)

export default component.exports